var map = {
	"./精工艺字/不锈钢背发光字.jpg": 4854,
	"./精工艺字/亚克力烤漆字.jpg": 4015,
	"./精工艺字/发光字1.jpg": 7408,
	"./精工艺字/发光字2.jpg": 399,
	"./精工艺字/树脂字.jpg": 8948,
	"./精工艺字/烤漆字.jpg": 3621,
	"./精工艺字/电镀金字.jpg": 8985,
	"./精工艺字/电镀金字样.jpg": 5438,
	"./精工艺字/背发光字.jpg": 11,
	"./精工艺字/背发光字1.jpg": 7734,
	"./精工艺字/背面发光迷你字.jpg": 928,
	"./精工艺字/迷你字.jpg": 6276,
	"./精工艺字/迷你字1.jpg": 6403,
	"./精工艺字/铝字.jpg": 6842,
	"./精工艺字/铝烤漆字.jpg": 5452,
	"./精工艺字/铝烤漆标志.jpg": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4369;